import { pauseQueue, unPauseQueue } from 'services/attendant';
import { setInPause } from 'store/call/actions';
import sweetAlert from "utils/sweetAlert";
import { setModalOpened } from 'store/modal/actions';
import { setUserStatus, setPrePause } from 'store/user/actions';
import { StatusConstants } from 'utils/constants';
import { UserStore } from '../../../store/user/index';

export const setAttendantPause = (pauseReason: string) => {
  try {
    setPrePause(true)
    pauseQueue(pauseReason);
    const status = UserStore.getRawState().status;

    if (status === StatusConstants.WAITING) {
      setUserStatus(StatusConstants.PAUSED);
    }
    setInPause(true);
  } catch {
    setPrePause(false);
    console.log("Não foi possível entrar em pausa. Operação falhou");
    sweetAlert.error(
      "Não foi possível adicionar a pausa, entre em contato com o suporte"
    );
  }
}

export const removeAttendantPause = () => {
  try {
    unPauseQueue();
    setUserStatus(StatusConstants.UNPAUSE);
    setUserStatus(StatusConstants.WAITING);
    setInPause(false);
    setPrePause(false);
    setModalOpened(false);
  } catch {
    console.log("Não foi possível entrar em pausa. Operação falhou");
  }
}
